import { useCallback, useEffect, useState } from 'react';
import io from 'socket.io-client';

import { config } from '../../../config';
import { store } from '../../../store';

const useLivestreamWebSocket = (testSessionId) => {
  const [connection, setConnection] = useState(null);

  const state = store.getState();
  const { authentication: { token } = {} } = state;
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!testSessionId || !token) {
      return () => null;
    }

    const socket = io(config.REACT_APP_LIVESTREAM_SOCKET_URL, {
      auth: {
        token,
        testSessionId,
      },
      transports: ['websocket'],
    });

    setConnection(socket);

    socket.on('connect', () => {
      setIsConnected(true);
    });

    socket.on('disconnect', () => {
      setIsConnected(false);
    });

    socket.on('connect_error', (err) => {
      setIsConnected(false);
      setError(err.message);
    });

    return () => {
      if (socket) {
        socket.disconnect();
      }
    };
  }, [testSessionId, token]);

  const emitEvent = useCallback((event, data) => {
    if (connection) {
      connection.emit(event, data);
    }
  }, [connection]);

  const onEvent = useCallback((event, handler) => {
    if (connection) {
      connection.on(event, handler);
    }
  }, [connection]);

  const offEvent = useCallback((event, handler) => {
    if (connection) {
      connection.off(event, handler);
    }
  }, [connection]);

  return {
    emitEvent,
    onEvent,
    offEvent,
    isConnected,
    error,
  };
};

export default useLivestreamWebSocket;
